@if ( !isHidden ) {
<section class="lr-pad">
    <mat-expansion-panel [expanded]="true" [class]="['mutara-expansion-panel','background']" [hideToggle]="true"
        [disabled]="true">
        @if ( !!props.label || !!props.description ) {
        <mat-panel-title align="center" class="flex-full">
            <h2 class="mat-headline-2">{{props.label}}</h2>
            <mat-menu #info>
                <pre mat-menu-item>{{props.description}}</pre>
            </mat-menu>
        </mat-panel-title>
        }
        <mat-expansion-panel-content [ngClass]="['mutara-expansion-panel-content']">
            @if ( !!currentLink() ) {
            <markdown ngPreserveWhitespaces [disableSanitizer]="true" [class]="['agreement']" [src]='currentLink()?.toString()'></markdown>
            }
            <mat-divider></mat-divider>
            <ng-container #fieldComponent></ng-container>
        </mat-expansion-panel-content>
    </mat-expansion-panel>
</section>
}